import { Factory } from 'miragejs';

const FAKE_NAMES = ['Jane Doe', 'John Doe'];
const FAKE_EMAILS = ['jane.doe@qonto.com', 'john.doe@qonto.com'];

export default Factory.extend({
  fullName: i => FAKE_NAMES[i % FAKE_NAMES.length],
  email: i => FAKE_EMAILS[i % FAKE_EMAILS.length],
});
